import { useCallback } from 'react';

import { EndpointProductService } from 'common/services';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { handleResetCall } from 'features/call/call-base/store';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { ColdHandoffDaoService } from 'features/cold-handoff/services';
import { handleError } from 'features/notification/store';

export const useColdHandoffTakenClickHandlers = () => {
  const dispatch = useAppDispatch();
  const callId = useAppSelector(callIdSelector);

  const handleColdHandoffCancel = useCallback(async () => {
    try {
      await ColdHandoffDaoService.cancelHandoff({
        callId,
      });
    } catch (error) {
      dispatch(
        handleError({
          error,
          methodName: 'handleCancelCall',
        })
      );
    } finally {
      EndpointProductService.clearName();
      dispatch(handleResetCall()).unwrap();
    }
  }, [dispatch, callId]);

  return { handleColdHandoffCancel };
};
